import { writeCookie } from '@zapier/cookies';
import { AuthType, SignupType } from '../../types';
import { AUTH_TYPE_COOKIE_NAME } from '../../constants';

export function signupTypeToAuthType(
  signupType: SignupType
): AuthType | undefined {
  const typeMap: { [key in SignupType]?: AuthType } = {
    direct: 'email',
    'google-sso': 'google',
    'facebook-sso': 'facebook',
    'microsoft-sso': 'microsoft',
  } as const;

  return typeMap[signupType];
}

export function storeAuthType(authType: AuthType) {
  writeCookie(AUTH_TYPE_COOKIE_NAME, authType, {
    category: 'essential', // We can't write this cookie if the user has not consented. Something to keep in mind.
  });
}

export function removeStoredAuthType() {
  writeCookie(AUTH_TYPE_COOKIE_NAME, '', {
    category: 'essential', // We can't write this cookie if the user has not consented. Something to keep in mind.
    expires: new Date(Date.now() - 10),
  });
}
